import styled from 'styled-components';
import { css, breakpoints } from '../../../styles/theme';
import BasketTemplate from './BasketTemplate';
import { ConfigMainGrid as Grid } from '@components/Grid';
import { rem } from 'polished';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV, isMarketGB } from '../../../constants/main';

export const ConfigMainGrid = styled(Grid)`
    @media (max-width: ${breakpoints.lg}px) {
        max-width: unset;
    }
`;

export const BasketStyled = styled(BasketTemplate)`
    .sticky {
        padding: 0;
        position: sticky;
        top: ${({ isUserLoggedInAsDealer }) => (isUserLoggedInAsDealer ? rem(36) : 0)};
        z-index: 999;
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey22};
        border-top: 1px solid ${({ theme }) => theme.colors.grey22};
    }
    .mobilePriceSection {
        position: sticky;
        bottom: 0;
        background: ${({ theme }) => (isBrandDS ? theme.colors.white : theme.colors.grey8)};
        border-top-right-radius: ${rem(20)};
        border-top-left-radius: ${rem(20)};
        z-index: 999;
        box-shadow: 0 -1px 6px 0 ${({ theme }) => theme.colors.black};

        @media (min-width: ${breakpoints.sm}px) {
            display: none;
        }
    }

    .isOpenPriceSummary {
        position: relative;

        #summary {
            position: fixed;
            z-index: 999999999;
            width: 100%;
            height: 100%;
            background: ${({ theme }) => (isBrandDS ? theme.colors.white : theme.colors.grey7)};

            .title {
                background: ${({ theme }) => (isBrandDS ? theme.colors.white : theme.colors.grey7)};
            }
        }
    }

    .mobilePriceSectionArrow {
        text-align: center;
        cursor: pointer;
        padding: ${rem(15)} 0 0 0;

        svg {
            path {
                stroke: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .mobilePriceSectionPrice {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 ${rem(15)} ${rem(10)} ${rem(15)};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        .price {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
        }
    }

    .mobilePriceSectionHelp {
        color: ${({ theme }) => theme.colors.white};
        background: ${({ theme }) => theme.colors.blue2};
        height: ${rem(40)};
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: -${rem(15)};
        padding: 0 ${rem(15)};
        cursor: pointer;

        span {
            display: flex;
            align-items: center;

            svg {
                g {
                    path {
                        fill: ${({ theme }) => theme.colors.white} !important;
                    }
                }
            }
        }

        .phone,
        .label {
            svg {
                margin-left: ${rem(5)};
            }
        }

        ${isBrandAP &&
        css`
            background: ${({ theme }) => theme.colors.black};
            padding: ${rem('10px')};

            .label {
                font-weight: normal;
            }

            .label,
            .phone {
                font-size: ${rem('12px')};
                white-space: nowrap;
            }
        `}

        ${isBrandDS &&
        css`
            background: ${({ theme }) => theme.colors.black1};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        `}

        ${isBrandAC &&
        css`
            background: ${({ theme }) => theme.colors.blue2};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        `}

        ${isBrandOV &&
        isMarketGB &&
        css`
            background: ${({ theme }) => theme.colors.black2};

            .phone {
                svg {
                    width: ${rem(30)};
                    height: ${rem(15)};
                    margin-right: ${rem(5)};
                    margin-bottom: ${rem(4)};

                    path {
                        fill: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        `}

        ${isBrandOV &&
        !isMarketGB &&
        css`
            background: ${({ theme }) => theme.colors.black2};
        `}
    }
`;
